// src/components/ui/Badge.jsx
import React from 'react';
import Icon from '../appIcon';

const Badge = ({
    children,
    variant = 'default',
    className = '',
    icon,
    ...props
}) => {
    const baseStyles = 'inline-flex items-center px-3 py-1 rounded-full text-sm font-medium transition-colors';

    const variants = {
        default: 'bg-gray-100 text-gray-800 border border-gray-200',
        secondary: 'bg-blue-100 text-blue-800 border border-blue-200',
        success: 'bg-green-100 text-green-800 border border-green-200',
        warning: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
        danger: 'bg-red-100 text-red-800 border border-red-200'
    };

    return (
        <span
            className={`${baseStyles} ${variants[variant]} ${className}`}
            {...props}
        >
            {icon && <Icon name={icon} size={14} className="mr-1" />}
            {children}
        </span>
    );
};

export default Badge;